import {
  Menu,
} from '@/internal';

export default (payload = {}) => {
  // Detect Safari and iOS
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  const handleInstallClick = () => {
    if (window.deferredPrompt) {
      // Chrome-based browsers - use programmatic prompt
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice.then(() => {
        window.deferredPrompt = null;
      });
    } else if (isIOS && isSafari) {
      // iOS Safari - show drawer with instructions (similar to Logs menu in MobileTabs)
      window.app.vue.$store.dispatch('ui/setInstallPromptActive', true);
    }
  };

  return new Menu({
    title: 'Tools',
    open: true,
    menuItems: [
      // {
      //   route: window.app.findRouteByName('dashboard'),
      // },
      // {
      //   route: window.app.findRouteByName('planner/index'),
      // },
      // {
      //   route: window.app.findRouteByName('goal/index'),
      // },
      {
        route: window.app.findRouteByName('analytics/index'),
      },
      {
        title: 'Install App',
        icon: 'mobile-screen',
        onClick: handleInstallClick,
        // Show if not installed AND (has deferredPrompt OR is iOS Safari)
        when: !window.pwaInstalled && (window.deferredPrompt !== null || (isIOS && isSafari)),
      },
    ],
  });
};
